import { Location } from '@angular/common';
import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { TranslatePipe } from '@core/i18n-legacy';
import { HeadingComponent, SpinnerComponent } from '@core/user-interface-legacy';
import type { SelectGroupOption } from '@core/user-interface-legacy';
import { SubscriptionService } from '@recruitee/company-logic';
import {
  EvaluationDropdownHeaderComponent,
  EvaluationSelectionItemComponent,
} from '@recruitee/evaluations-ui';
import { FeatureDiscoveryBannerComponent } from '@recruitee/feature-discovery-smart-ui';

@Component({
  selector: 'rt-add-evaluation-selection-step',
  templateUrl: './add-evaluation-selection-step.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslatePipe,
    EvaluationDropdownHeaderComponent,
    EvaluationSelectionItemComponent,
    HeadingComponent,
    SpinnerComponent,
    FeatureDiscoveryBannerComponent,
  ],
})
export class AddEvaluationSelectionStepComponent {
  private readonly subscriptionService = inject(SubscriptionService);
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  public readonly canManageInterviewTemplates = input<boolean>(false);
  public readonly loading = input.required<boolean>();
  public readonly recommendedTemplate = input<SelectGroupOption>();
  public readonly showBackButton = input<boolean>(false);

  public readonly goToEvaluation = output<void>();
  public readonly goToQuickEvaluation = output<void>();
  public readonly goToRecommendedEvaluation = output<void>();
  public readonly goBack = output<void>();

  protected get shouldShowScaleBanner(): boolean {
    return !this.subscriptionService.isTrial();
  }

  protected openEvaluationScaleSettings(): void {
    const urlTree = this.router.createUrlTree(['/settings/candidate_evaluation'], {
      queryParams: { edit: 'scale' },
    });
    window.open(this.location.prepareExternalUrl(this.router.serializeUrl(urlTree)), '_blank');
  }
}
